/**
 * Product sticky ATC bar: show while scrolling down, hide while scrolling up.
 * Complements Prestige ProductStickyBar (form/footer intersection → is-visible).
 */
(function () {
  'use strict';

  var SCROLL_DELTA = 40;
  var lastY = 0;
  var ticking = false;
  var scrollUp = false;

  function bars() {
    return document.querySelectorAll('product-sticky-bar.product-sticky-bar');
  }

  function applyScrollClass() {
    bars().forEach(function (el) {
      el.classList.toggle('is-scroll-up', scrollUp);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = Math.max(0, window.scrollY || window.pageYOffset || 0);
      var delta = y - lastY;
      if (delta > SCROLL_DELTA) {
        scrollUp = false;
        lastY = y;
        applyScrollClass();
      } else if (delta < -SCROLL_DELTA) {
        scrollUp = true;
        lastY = y;
        applyScrollClass();
      }
    });
  }

  function bind() {
    lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
    applyScrollClass();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
